const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all
}

const actions = {
  add ({ commit }, place) {
    commit('addPlace', place)
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  addPlace (state, place) {
    state.all.push(place)
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
